import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalSlice";
import { serviceApi } from "./ServiceApi";

const store = configureStore({
  reducer: {
    global: globalReducer,
    [serviceApi.reducerPath]: serviceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      serviceApi.middleware,
      
    ),
});

export default store;